import type { RankChangeType } from "./types"

export type RankChange = {
  type: RankChangeType
  value?: number
}

export const computeRankChange = (rank: number, previousRank?: number | null): RankChange => {
  if (previousRank == null) {
    return { type: "new" }
  }
  if (previousRank === rank) {
    return { type: "same" }
  }
  if (previousRank > rank) {
    return { type: "up", value: previousRank - rank }
  }
  return { type: "down", value: rank - previousRank }
}
